export default "__VITE_ASSET__CBbbBNNm__"